import {
    Alert, Avatar, Button, Card, Col, Divider, Image, Input, Modal, Row, Select, Spin, Table, Tag, Timeline, Typography
} from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import { dateFormat } from '../../Utils/formatDate';
import heic2any from "heic2any";

const { Option } = Select;
function DelegationOvertime() {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [statusFilter, setStatusFilter] = useState('');
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [detailData, setDetailData] = useState();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [rejectReason, setRejectReason] = useState('');
    const [isRejectModalVisible, setIsRejectModalVisible] = useState(false);
    const [convertedImages, setConvertedImages] = useState([]);


    const titlePage = 'Overtime Data';
    useEffect(() => {
        const convertHeicImages = async () => {
            if (!detailData?.overtime_image) return;

            const results = await Promise.all(
                detailData.overtime_image.map(async (img) => {
                    try {
                        const url = img.image;

                        // Kalau HEIC, fetch dan konversi ke JPEG
                        if (url?.toLowerCase().endsWith(".heic")) {
                            const response = await fetch(url, { mode: "cors" });
                            const blob = await response.blob();

                            const converted = await heic2any({
                                blob,
                                toType: "image/jpeg",
                                quality: 0.9,
                            });

                            return {
                                ...img,
                                convertedUrl: URL.createObjectURL(converted),
                            };
                        } else {
                            // Kalau bukan HEIC, langsung tampilkan
                            return { ...img, convertedUrl: url };
                        }
                    } catch (error) {
                        console.error("Gagal konversi HEIC:", error);
                        return { ...img, convertedUrl: img.image };
                    }
                })
            );

            setConvertedImages(results);
        };

        convertHeicImages();
    }, [detailData]);

    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => {
                ++index;
                return (page.pagination.current - 1) * page.pagination.pageSize + index;
            },
        },
        {
            title: 'User Code',
            dataIndex: 'users_code',
            key: "users_code",
            render: (text, record) => {
                if (record.users !== null) return record.users.users_code;
            }
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: "name",
            render: (text, record) => {
                if (record.users !== null) return record.users.name;
            }
        },
        {
            title: 'Description',
            dataIndex: 'desc',
            key: "desc",
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: "status",
            render: (text, record) => {
                switch (record.overtime_approval[0].status_approval_id) {
                    case 2: return <Tag color='green'>Approved</Tag>;
                    case 3: return <Tag color='red'>Rejected</Tag>;
                    default: return <Tag color='yellow'>{record.status}</Tag>;
                }
            }
        },
        // {
        //     title: 'Created At',
        //     dataIndex: 'created_at',
        //     key: "created_at",
        //     render: (text, record) => {
        //         return record.created_at !== "" ? dateFormat(record.created_at) : "-";
        //     }
        // },
        // {
        //     title: 'Updated At',
        //     dataIndex: 'updated_at',
        //     key: "updated_at",
        //     render: (text, record) => {
        //         return record.updated_at !== "" ? dateFormat(record.updated_at) : "-";
        //     }
        // },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                return (
                    <Button
                        type="default"
                        style={{ marginRight: 10 }}
                        onClick={() => showDetailModal(record)}
                    >
                        <b style={{ marginLeft: 5 }}>Detail</b>
                    </Button>
                );
            },
        },
    ];

    const showDetailModal = (data) => {
        getApi('GET', '/overtime/' + data.overtime_id, 'detail');
    };

    useEffect(() => {
        getApi("GET", `/overtime?userdelegation=true&search=${search}&page=${page.pagination.current}&statusDelegation=${statusFilter}`, 'overtime');
    }, [JSON.stringify(page), isAlert, statusFilter]);

    const getApi = (method, url, type) => {
        setLoading(true);
        const dataReq = {
            method,
            url,
            data: {
                headers: { Authorization: 'Bearer ' + token }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                if (type === 'detail') {
                    setDetailData(res.data);
                    setIsModalVisible(true);
                } else {
                    setData(res.data.data);
                    setPage({
                        ...page,
                        pagination: {
                            ...page.pagination,
                            total: res.data.total_data
                        }
                    });
                }
            }
            setLoading(false);
        }).catch((e) => {
            setLoading(false);
        });
    };

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        const dataReq = {
            method,
            url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        await apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setIsAlert(true);
                setTextAlert(res.message);
            } else {
                modalError(res.message);
            }
            setLoading(false);
        }).catch((e) => {
            console.error(e.message);
            setLoading(false);
        });
    };

    const handleBulkAction = (type) => {
        const statusId = type === 'approve' ? 2 : 3;
        const ids = selectedRows.map((row) => row.overtime_id);

        if (ids.length === 0) {
            modalError('No reimbursement selected.');
            return;
        }

        if (type === 'reject') {
            setIsRejectModalVisible(true);
            return;
        }

        Modal.confirm({
            title: 'CONFIRMATION',
            content: `Are you sure you want to approve ${selectedRowKeys.length} request(s)?`,
            // onOk: () => {
            //     const promises = selectedRows.map((row) =>
            //         postApi('PUT', '/overtimeapprovalfinal/' + row.overtime_id, {
            //             status_approval_id: 2
            //         })
            //     );
            //     Promise.all(promises).then(() => {
            //         setSelectedRowKeys([]);
            //         setSelectedRows([]);
            //         setIsAlert(true);
            //         setTextAlert(`Successfully approved ${selectedRowKeys.length} request(s).`);
            //         getApi("GET", `/overtime?userdelegation=true&search=${search}&page=${page.pagination.current}`, 'overtime');
            //     });
            // }
            onOk: async () => {
                setLoading(true);
                try {
                    const dataReq = {
                        method: 'PUT',
                        url: '/overtimeapprovaldelegationbulk',
                        data: {
                            data: {
                                ids,
                                status_approval_id: statusId,
                                reason: type === 'reject' ? rejectReason : undefined,
                            },
                            headers: {
                                Authorization: 'Bearer ' + token,
                            },
                        },
                    };

                    const res = await apiCall(dataReq);
                    if (res.status === 'success') {
                        setTextAlert(res.message);
                        setIsAlert(true);
                        setRejectReason('');
                        setSelectedRowKeys([]);
                        setSelectedRows([]);
                        getApi("GET", '/overtime?userdelegation=true&search=' + search + '&page=' + page.pagination.current, 'leave_paid');
                    } else {
                        modalError(res.message);
                    }
                } catch (e) {
                    modalError(e.message);
                } finally {
                    setLoading(false);
                }
            }
        });

    };

    const submitRejectReason = async () => {
        const statusId = 3;
        const ids = selectedRows.map((row) => row.overtime_id);
        if (!rejectReason.trim()) {
            modalError("Reason is required for rejection.");
            return;
        }

        // const promises = selectedRows.map((row) =>
        //     postApi('PUT', '/overtimeapprovalfinal/' + row.overtime_id, {
        //         status_approval_id: 3,
        //         reason: rejectReason
        //     })
        // );

        // Promise.all(promises).then(() => {
        // setSelectedRowKeys([]);
        // setSelectedRows([]);
        // setRejectReason('');
        // setIsRejectModalVisible(false);
        // setIsAlert(true);
        //     setTextAlert(`Successfully rejected ${selectedRowKeys.length} request(s).`);
        //     getApi("GET", `/overtime?userdelegation=true&search=${search}&page=${page.pagination.current}`, 'overtime');
        // });
        setLoading(true);
        try {
            const dataReq = {
                method: 'PUT',
                url: '/overtimeapprovaldelegationbulk',
                data: {
                    data: {
                        ids,
                        status_approval_id: statusId,
                        reason: rejectReason,
                    },
                    headers: {
                        Authorization: 'Bearer ' + token,
                    },
                },
            };

            const res = await apiCall(dataReq);
            if (res.status === 'success') {
                setTextAlert(res.message);
                setIsAlert(true);
                setRejectReason('');
                setIsRejectModalVisible(false);
                setSelectedRowKeys([]);
                setSelectedRows([]);
                getApi("GET", '/overtime?userdelegation=true&search=' + search + '&page=' + page.pagination.current, 'leave_paid');
            } else {
                modalError(res.message);
            }
        } catch (e) {
            modalError(e.message);
        } finally {
            setLoading(false);
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({ pagination, filters, ...sorter });
        if (pagination.pageSize !== page.pagination?.pageSize) setData([]);
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    };

    function checkDelegation(item) {
        const items = item.overtime_approval;
        return items.length === 1 && items[0].status_approval_id === 1;
    }

    const rowSelection = {
        selectedRowKeys,
        onChange: (keys, rows) => {
            setSelectedRowKeys(keys);
            setSelectedRows(rows);
        },
        getCheckboxProps: (record) => ({
            disabled: record.status !== 'Process' || !checkDelegation(record),
        }),
    };

    return (
        <div>
            <Helmet><title>{titlePage}</title></Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <h3>Overtime Data</h3>
            <Row>
                <Col span={8}>
                    <Search
                        placeholder="Search"
                        allowClear
                        enterButton="Search"
                        size="middle"
                        onSearch={searchData}
                    />
                </Col>
                <Col span={8}>
                    <Select
                        placeholder="Filter by status"
                        allowClear
                        style={{ width: 160, marginLeft: 10 }}
                        onChange={setStatusFilter}
                    >
                        <Option value="Process">Process</Option>
                        <Option value="Approved">Approved</Option>
                        <Option value="Rejected">Rejected</Option>
                    </Select>
                </Col>
            </Row>
            <br />
            <Row style={{ marginBottom: 16 }}>
                <Col>
                    <Button
                        type="primary"
                        disabled={selectedRowKeys.length === 0}
                        onClick={() => handleBulkAction('approve')}
                        style={{ marginRight: 8 }}
                    >
                        Approved ({selectedRowKeys.length})
                    </Button>
                    <Button
                        danger
                        disabled={selectedRowKeys.length === 0}
                        onClick={() => handleBulkAction('reject')}
                    >
                        Rejected ({selectedRowKeys.length})
                    </Button>
                </Col>
            </Row>

            <Table
                size="middle"
                rowSelection={rowSelection}
                rowKey={(record) => record.overtime_id}
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
            />

            <Modal
                title="Reject Reason"
                open={isRejectModalVisible}
                onCancel={() => setIsRejectModalVisible(false)}
                onOk={submitRejectReason}
                okText="Submit"
            >
                <p>Please provide a reason for rejection:</p>
                <Input.TextArea
                    rows={4}
                    value={rejectReason}
                    onChange={(e) => setRejectReason(e.target.value)}
                    style={{ width: '100%' }}
                />
            </Modal>

            <Modal
                title="Overtime Detail"
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
                width={900}
            >
                {loading ? (
                    <Spin tip="Loading..." style={{ display: "block", textAlign: "center" }} />
                ) : detailData && (
                    <Card>
                        <Typography.Title level={5}>Overtime Info</Typography.Title>
                        <Row gutter={[16, 16]}>
                            <Col span={12}><Typography.Text strong>Compensation:</Typography.Text>
                                <Typography.Paragraph>{detailData.compensation}</Typography.Paragraph>
                            </Col>
                            <Col span={12}><Typography.Text strong>Date:</Typography.Text>
                                <Typography.Paragraph>{new Date(detailData.date).toLocaleDateString()}</Typography.Paragraph>
                            </Col>
                            <Col span={12}><Typography.Text strong>Description:</Typography.Text>
                                <Typography.Paragraph>{detailData.desc}</Typography.Paragraph>
                            </Col>
                            <Col span={12}><Typography.Text strong>Status:</Typography.Text>
                                <Typography.Paragraph>{detailData.status}</Typography.Paragraph>
                            </Col>
                        </Row>

                        <Divider />

                        <Typography.Title level={5}>Overtime Duration</Typography.Title>
                        <Row gutter={[16, 16]}>
                            <Col span={12}><Typography.Text strong>Before Shift:</Typography.Text>
                                <Typography.Paragraph>{detailData.before_shift_overtime_duration || "-"}</Typography.Paragraph>
                            </Col>
                            {/* <Col span={12}><Typography.Text strong>Rest Before Shift:</Typography.Text>
                                <Typography.Paragraph>{detailData.before_shift_rest_duration || "-"}</Typography.Paragraph>
                            </Col> */}
                            <Col span={12}><Typography.Text strong>After Shift:</Typography.Text>
                                <Typography.Paragraph>{detailData.after_shift_overtime_duration || "-"}</Typography.Paragraph>
                            </Col>
                            {/* <Col span={12}><Typography.Text strong>Rest After Shift:</Typography.Text>
                                <Typography.Paragraph>{detailData.after_shift_rest_duration || "-"}</Typography.Paragraph>
                            </Col> */}
                        </Row>

                        <Divider />

                        <Typography.Title level={5}>Overtime Images</Typography.Title>
                        <Row gutter={[16, 16]}>
                            {convertedImages?.length > 0 ? (
                                convertedImages.map((img) => (
                                    <Col key={img.overtime_image_id} span={6}>
                                        <Image
                                            alt={`Overtime ${img.overtime_image_id}`}
                                            src={img.convertedUrl}
                                            width={200}
                                            height={200}
                                            style={{
                                                objectFit: "contain",
                                                borderRadius: "10px",
                                                border: '1px solid #F2F2F2'
                                            }}
                                        />
                                    </Col>
                                ))
                            ) : (
                                <Col span={24}>
                                    <Typography.Text>No overtime images</Typography.Text>
                                </Col>
                            )}
                        </Row>


                        <Divider />


                        <Typography.Title level={5}>Overtime Delegation</Typography.Title>
                        <Timeline mode="left" style={{ marginTop: 20 }}>
                            <Timeline.Item color="blue">
                                <Row gutter={8} align="middle">
                                    <Col>
                                        <Avatar src={detailData.users?.image} />
                                    </Col>
                                    <Col>
                                        <Typography.Text strong>{detailData.users?.name || "-"}</Typography.Text><br />
                                        <Tag color="blue">Requested</Tag><br />
                                        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                            {dateFormat(detailData.created_at) || "-"}
                                        </Typography.Text>
                                    </Col>
                                </Row>
                            </Timeline.Item>

                            {detailData.overtime_approval.map((approval) => (
                                <Timeline.Item
                                    key={approval.overtime_approval_id}
                                    color={
                                        approval.status_approval_id === 2
                                            ? "green"
                                            : approval.status_approval_id === 3
                                                ? "red"
                                                : "yellow"
                                    }
                                >
                                    <Row gutter={8} align="middle">
                                        <Col>
                                            <Avatar src={approval.user?.image} />
                                        </Col>
                                        <Col>
                                            <Typography.Text strong>{approval.user?.name || "-"}</Typography.Text><br />
                                            {detailData.users?.users_id === approval.user?.users_id ? (
                                                <Tag color="red">Dibatalkan</Tag>
                                            ) : (
                                                <Tag
                                                    color={
                                                        approval.status_approval_id === 2
                                                            ? "green"
                                                            : approval.status_approval_id === 3
                                                                ? "red"
                                                                : "yellow"
                                                    }
                                                >
                                                    {approval.status_approval?.status}
                                                </Tag>
                                            )}
                                            <br />
                                            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                                {dateFormat(approval.created_at) || "-"}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                </Timeline.Item>
                            ))}
                        </Timeline>

                    </Card>
                )}
            </Modal>
        </div>
    );
}

export default DelegationOvertime;